// Local minimal type for CURP-related validation
type CurpItem = { index: number; value: string; invalid: boolean };
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const cleanBase64 = (value: string) =>
  value.replace(/^data:(image|application)\/\w+;base64,/, '').trim();

export const validateCurp = (curp: string, birthYear: string) => {
  let parseBirthYear = parseInt(birthYear);
  if (curp !== '' && typeof curp !== 'undefined') {
    const stringCurp = curp.toUpperCase();
    const regex_text = /^[A-Z]+$/;
    const regex_number = /^[0-9]*$/;
    const curp_letters_array = stringCurp.split('');
    const curp_array: CurpItem[] = [];

    curp_letters_array.forEach((char, index) => {
      const curp_item = { index: index, value: char, invalid: false };
      curp_item.value = char;
      if (index < 4 && !regex_text.test(char)) {
        curp_item.invalid = true;
      } else if (index > 3 && index < 10 && !regex_number.test(char)) {
        // numero
        curp_item.invalid = true;
      } else if (index == 10 && !regex_text.test(char)) {
        // texto H|M
        curp_item.invalid = true;
      } else if (index > 10 && index < 14 && !regex_text.test(char)) {
        // Texto Entidad
        curp_item.invalid = true;
      } else if (index > 13 && index < 16 && !regex_text.test(char)) {
        // Texto Consonantes
        curp_item.invalid = true;
      } else if (index == 16) {
        // Numeros
        if (birthYear === '') {
          const numes = curp.substr(4, 6).split('');
          parseBirthYear = parseInt(numes[3] + numes[4] + numes[0] + numes[1]);
        }
        /*
         * Se cambia la validacion por esta razon en Número o letra asignado por la SEGOB
         * https://contribuyentealdia.com.mx/curp/digito-verificador/
         *
         */
        if (parseBirthYear < 2000 && !regex_number.test(char)) {
          curp_item.invalid = true;
        } else if (parseBirthYear > 1999 && !regex_text.test(char)) {
          curp_item.invalid = true;
        }
      } else if (index == 17 && !regex_number.test(char)) {
        // Numeros
        curp_item.invalid = true;
      }
      curp_array.push(curp_item);
    });

    const isValidCurp = curp_array.some((element) => element.invalid === true);

    // Second validation
    const re =
      /^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d)$/;
    const validado = curp.toUpperCase().match(re);
    if (!validado) {
      return !isValidCurp && false;
    } //Coincide con el formato general?

    if (validado != null) {
      //Validar que coincida el dígito verificador
      if (validado[2] != validateDigit(validado[1])) {
        return !isValidCurp && false;
      }

      const regex_text = /^[A-Z]+$/;
      const regex_number = /^[0-9]*$/;
      // curp_letters_array = curp.split("");
      let valid = true;
      curp_letters_array.forEach((char, index) => {
        if (index == 16) {
          // Numeros
          if (birthYear === '') {
            const numes = curp.substr(4, 6).split('');
            parseBirthYear = parseInt(numes[3] + numes[4] + numes[0] + numes[1]);
          }

          /*
           * Se cambia la validacion por esta razon en Número o letra asignado por la SEGOB
           * https://contribuyentealdia.com.mx/curp/digito-verificador/
           *
           */
          if (parseBirthYear < 2000 && !regex_number.test(char)) {
            valid = false;
          } else if (parseBirthYear > 1999 && !regex_text.test(char)) {
            valid = false;
          }
        }
      });
      return !isValidCurp && valid;
    }

    return !isValidCurp;
  }
  return false;
};

const validateDigit = (curp17: string) => {
  //Fuente https://consultas.curp.gob.mx/CurpSP/
  const diccionario = '0123456789ABCDEFGHIJKLMNÑOPQRSTUVWXYZ';
  let lngSuma = 0.0;
  let lngDigito = 0.0;
  for (let i = 0; i < 17; i++) lngSuma = lngSuma + diccionario.indexOf(curp17.charAt(i)) * (18 - i);
  lngDigito = 10 - (lngSuma % 10);
  if (lngDigito == 10) return 0;
  return lngDigito.toString();
};

export const validateKeyElectoral = (keyElectoral: string) => {
  if (keyElectoral !== '' && typeof keyElectoral !== 'undefined') {
    const stringKeyElectoral = keyElectoral.toUpperCase();

    const regex_text = /^[A-Z]+$/;
    const regex_number = /^[0-9]*$/;
    const regex_textandnumber = /^[A-Z0-9]*$/;
    const curp_letters_array = stringKeyElectoral.split('');
    const curp_array: CurpItem[] = [];
    // let claveInvalid = false;
    curp_letters_array.forEach((char, index) => {
      const curp_item = { index: index, value: char, invalid: false };
      curp_item.value = char;
      if (index < 6 && !regex_text.test(char)) {
        curp_item.invalid = true;
      } else if (index > 5 && index < 12 && !regex_number.test(char)) {
        // numero
        curp_item.invalid = true;
      } else if (index > 12 && !regex_textandnumber.test(char)) {
        curp_item.invalid = true;
      }

      // if (curp_item.invalid == true) {
      //   claveInvalid = true;
      // }

      curp_array.push(curp_item);
    });

    const isValidKeyElectoral = curp_array.some((element) => element.invalid === true);

    const validateKeyElectoral =
      !isValidKeyElectoral && validateLengthKeyElectoral(stringKeyElectoral, isValidKeyElectoral);
    return validateKeyElectoral;
  }
  return false;
};

const validateLengthKeyElectoral = (key: string, keyInvalid: boolean) => {
  if (key.length === 18 && !keyInvalid) {
    return true;
  }
  return false;
};

export const validateYear = (year: string) => {
  const stringYearRegister = parseInt(year === '' ? '0' : year.trim());
  const isValidRange = stringYearRegister > 1900 && stringYearRegister < 2100;
  return isValidRange;
};

export const validateCIC = (cic: string) => {
  const regex_number = /^[0-9]*$/;
  const cic_digits_array = cic.split('');
  const cic_array: CurpItem[] = [];
  cic_digits_array.forEach((char, index) => {
    const cic_item = { index: index, value: char, invalid: false };
    cic_item.value = char;
    if (!regex_number.test(char)) {
      cic_item.invalid = true;
    } else if (index > 9) {
      cic_item.invalid = true;
    }

    cic_array.push(cic_item);
  });

  const isValidCic = cic_array.some((element) => element.invalid === true);

  const checkLenght = regex_number.test(cic) && cic_digits_array.length === 9;

  return !isValidCic && checkLenght;
};

export const validateOCR = (ocr: string) => {
  const regex_number = /^[0-9]*$/;
  const ocr_digits_array = ocr.split('');
  const cic_array: CurpItem[] = [];
  ocr_digits_array.forEach((char, index) => {
    const cic_item = { index: index, value: char, invalid: false };
    cic_item.value = char;
    if (!regex_number.test(char)) {
      cic_item.invalid = true;
    } else if (index > 12) {
      cic_item.invalid = true;
    }

    cic_array.push(cic_item);
  });

  const isValidOcr = cic_array.some((element) => element.invalid === true);

  const checkLenght =
    regex_number.test(ocr) && (ocr_digits_array.length === 12 || ocr_digits_array.length === 13);

  return !isValidOcr && checkLenght;
};

export const sanitizedTextToNumber = (
  e: { target: { value: string } },
  field: { onChange: (arg0: string) => string },
) => {
  const sanitizedValue = e.target.value.replace(/[^0-9]/g, '');
  return field.onChange(sanitizedValue);
};
